import {NavItem} from "../components/FormNav/NavItem";
import {NavItemType} from "../components/FormNav/NavItemType";
import FormPages from "./FormPages";

export const REV_TRUST_BASE_URL = "/Profile/${id}/ClientProfile/EstateFlowchart/${flowchartId}/RevocableTrust/${estateItemId}/";

export const RevocableTrustFormPages: NavItem[] = [
    {
        id: FormPages.BASIC_INFORMATION.id,
        displayName: FormPages.BASIC_INFORMATION.displayName,
        type: NavItemType.PAGE,
        index: 0,
        pathTemplate: REV_TRUST_BASE_URL + FormPages.BASIC_INFORMATION.id
    } as NavItem,
    {
        id: FormPages.BENEFICIARIES_AT_FIRST_DEATH.id,
        displayName: FormPages.BENEFICIARIES_AT_FIRST_DEATH.displayName,
        type: NavItemType.PAGE,
        index: 1,
        pathTemplate: REV_TRUST_BASE_URL + FormPages.BENEFICIARIES_AT_FIRST_DEATH.id
    } as NavItem,
    {
        id: FormPages.REMAINDER_BENEFICIARIES.id,
        displayName: FormPages.REMAINDER_BENEFICIARIES.displayName,
        type: NavItemType.PAGE,
        index: 2,
        pathTemplate: REV_TRUST_BASE_URL + FormPages.REMAINDER_BENEFICIARIES.id
    } as NavItem,
    {
        id: FormPages.ADDITIONAL_DISTRIBUTIONS.id,
        displayName: FormPages.ADDITIONAL_DISTRIBUTIONS.displayName,
        type: NavItemType.PAGE,
        index: 3,
        pathTemplate: REV_TRUST_BASE_URL + FormPages.ADDITIONAL_DISTRIBUTIONS.id
    } as NavItem
]